var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("timeline-item-card", {
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "b-row",
              {
                staticClass:
                  "align-items-center justify-content-center justify-content-md-start",
              },
              [
                _vm.isUpdate
                  ? _c("b-col", { attrs: { cols: "12", lg: "" } }, [
                      _c(
                        "span",
                        {
                          staticClass: "bold",
                          class: { "text-capitalize": _vm.isCommon },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.fieldText) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showValueOnNewLine ? _c("br") : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        { class: { oblique: _vm.isEmpty(_vm.value.from) } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.fieldValue(_vm.value.from)) +
                              "\n        "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isUpdate
                  ? _c(
                      "b-col",
                      {
                        staticClass: "d-flex flex-row justify-content-center",
                        attrs: { cols: "1" },
                      },
                      [
                        _c("icon", {
                          staticClass: "d-none d-lg-block",
                          staticStyle: { "font-size": "1.2rem" },
                          attrs: { name: "long-arrow-right" },
                        }),
                        _vm._v(" "),
                        _c("icon", {
                          staticClass: "d-sm-block d-lg-none my-3",
                          staticStyle: { "font-size": "1.2rem" },
                          attrs: { name: "long-arrow-down" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("b-col", { attrs: { cols: "12", lg: "" } }, [
                  _c(
                    "span",
                    {
                      staticClass: "bold",
                      class: { "text-capitalize": _vm.isCommon },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.fieldText) + "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showValueOnNewLine ? _c("br") : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      class: {
                        oblique: _vm.isEmpty(
                          _vm.parseValue({
                            value: _vm.value,
                            operation: _vm.operation,
                          })
                        ),
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.fieldValue(
                              _vm.parseValue({
                                value: _vm.value,
                                operation: _vm.operation,
                              })
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "b-row",
              {
                staticClass: "justify-content-between align-items-center",
                attrs: { "no-gutters": "" },
              },
              [
                _c("i18n", {
                  staticClass: "mb-0",
                  attrs: {
                    path: "client-profile.changelog.changeMessage",
                    tag: "p",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "name",
                      fn: function () {
                        return [
                          _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getChangelogName(_vm.userDetails)) +
                                "\n          "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "operation",
                      fn: function () {
                        return [
                          _c("span", { staticClass: "bold text-lowercase" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.getChangelogOperation(_vm.operation)
                                ) +
                                "\n          "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "type",
                      fn: function () {
                        return [
                          _c("span", { staticClass: "text-primary" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getChangelogType(_vm.type)) +
                                "\n          "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("p", { staticClass: "tiny-f mb-0" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("formatDateHour")(_vm.insertionTimestamp)) +
                      "\n      "
                  ),
                ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }